/*=========================================================================================
  File Name: moduleOnboardingAdmin.js
  Description: OnboardingAdmin Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleOnboardingAdminState.js'
import mutations from './moduleOnboardingAdminMutations.js'
import actions from './moduleOnboardingAdminActions.js'
import getters from './moduleOnboardingAdminGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
